<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Usuarios</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <!-- <v-toolbar-items> -->
                  <v-btn color="grey darken-2" dark class="mb-1" v-on="on">
                    Nuevo
                  </v-btn>
                <!-- </v-toolbar-items> -->
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-select
                          :items="listRolesActivas"
                          v-model="editedItem.role"
                          label="Role"
                          item-value="id"
                          item-text="name"
                          :rules="notBlankRules"
                          @change="changeRole($event)"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.role==6 || editedItem.role==7 || editedItem.role==8">
                          <v-select
                          :items="listSalas"
                          v-model="editedItem.sala_id"
                          label="Salas"
                          item-value="id"
                          item-text="nombre"
                          :rules="notBlankRules"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.role==3 ||editedItem.role==4 || editedItem.role==5">
                          <v-select
                          :items="getAllPonencias"
                          v-model="editedItem.ponencia"
                          label="Ponencia"
                          item-text="magistrado"
                          item-value="user_id"
                          return-object
                          :rules="notBlankRules"
                          ></v-select>
                        </v-flex>
                        <!-- <v-flex xs12>
                          <v-select
                          v-if="editedItem.role === 5"
                          :items="listJuzgados"
                          v-model="editedItem.juzgado_id"
                          label="Juzgado"
                          item-value="id"
                          item-text="nombre"
                          :rules="notBlankRules"
                          ></v-select>
                        </v-flex> -->
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.nombre" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field v-model.trim="editedItem.primer_apellido" label="Primer Apellido" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field v-model.trim="editedItem.segundo_apellido" label="Segundo Apellido">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.email" label="Email" :rules="emailRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1  && roleUser == 'superadmin'"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox v-if="editedIndex > -1"
                            v-model="changePassword"
                            label="Cambiar Contraseña"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 v-if="editedIndex == -1 || changePassword">
                          <v-text-field v-model.trim="editedItem.password" label="Contraseña" :type="show ? 'text' : 'password'"
                                        :rules="notBlankRules"
                          >
                          </v-text-field>
                          <v-text-field v-model.trim="editedItem.password_confirmation" label="Confirmar Contraseña" :type="show ? 'text' : 'password'"
                                        :rules="notBlankRules"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" @click.native="editUser(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Actualizar</v-btn>
                          <v-btn v-else color="yellow darken-2" @click.native="addUser(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog><!-- end dialog edit o save-->
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-row
                align="center"
                justify="space-around"
              >
                <v-col cols="4" class="mb-n6">
                  <v-text-field
                    v-model="buscarNombre"
                    label="Nombre ó Email"
                    item-value="id"
                    item-text="giro"
                    outlined
                    clearable
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="mb-n6">
                  <v-autocomplete
                    v-model="filtrarRol"
                    :items="listRolesActivas"
                    label="Rol"
                    item-value="id"
                    item-text="name"
                    outlined
                    clearable
                    dense
                    @change="filtrarPonencia='', getUsers()"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="4" class="mb-n6">
                  <v-autocomplete
                    v-model="filtrarPonencia"
                    :items="getAllPonencias"
                    label="Ponencia"
                    item-value="id"
                    :item-text=" item => 'Ponencia ' + item.magistrado "
                    outlined
                    clearable
                    dense
                    @change="filtrarRol='', getUsers()"
                  >
                  </v-autocomplete>
                </v-col>
                <v-btn
                  dark
                  class="ma-2 mb-n4"
                  color="#24406d"
                  @click="getUsers()"
                >
                  Buscar
                </v-btn>
              </v-row><br>
            </v-card-text>
          </v-card>
          <v-data-table
            :headers="headers"
            :items="listUsers"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loading"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.ncompleto="{ item }">
              <span v-if="item.primer_apellido == item.nombre"> {{ item.nombre }} </span>
              <span v-else>
                {{ item.nombre }} {{ item.primer_apellido }} {{ item.segundo_apellido}}
              </span>
            </template>
            <template v-slot:item.rol="{ item }">
              {{ item.roles[0].name }}
              <span v-if="item.presidente==1">
                (PRESIDENTE)
              </span>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
              >mdi-check-bold</v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
              >mdi-minus</v-icon>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon color="orange" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon class="mr-2" v-if="roleUser=='superadmin' && !item.deleted_at" color="red" @click="deleteUser(item)">mdi-close</v-icon>
              <v-icon v-if="!item.deleted_at && item.nombre!='superadmin'" color="blue"
                @click="startImpersonated(item)"
              >mdi-account-supervisor-circle-outline
              </v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="listUsers.length > itemsPerPage">
            <v-pagination v-model="page" :length="pageCount" :total-visible='7'></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      buscarNombre: '',
      filtrarRol: '',
      filtrarPonencia: '',
      changePassword:false,
      valid: true,
      dialog: false,
      loading:false,
      activo: true,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      show: false,
      headers: [
        { text: 'Nombre', value: 'ncompleto', sortable: true, align: 'left' },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Rol', value: 'rol', sortable: true },
        { text: 'Magistrado', value: 'ponencia.magistrado', sortable: true },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action' }
      ],
      editedIndex: -1,
      editedItem: {
        role:'',
        sala_id:'',
        ponencia_id:'',
        ponencia:'',
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        email:'',
        password: '',
        password_confirmation:'',
      },
      defaultItem: {
        role:'',
        sala_id:'',
        ponencia_id:'',
        ponencia:'',
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        email:'',
        password: '',
        password_confirmation:'',
      },
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      emailRules: [
        v => !!v || 'El campo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingrese un correo valido',
      ]
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    ...mapGetters([
      "listUsers",
      "listRoles",
      "listRolesActivas",
      "listSalas",
      "roleUser",
      "getAllPonencias"
    ]),
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
    },
  },
  mounted() {
    this.getUsers();
    this.getRoles();
    this.getSalas();
    this.getPonencias();
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    changeRole(e){
      if (e == 1 || e == 2) {
        this.editedItem.sala_id = ''
        this.editedItem.ponencia_id = ''
      }
      if (e == 3 || e == 4 || e == 5 || e == 6 || e == 9) {
        this.editedItem.sala_id = ''
      }
      if (e == 7 || e == 8 ) {
        this.editedItem.ponencia_id = ''
        this.editedItem.ponencia= ''
      }
      if (e == 9) {
        this.editedItem.sala_id = 10
      }
    },
    getSalas() {
      this.$store.dispatch("GET_SALAS",  { url: "/salas" } );
    },
    getUsers() {
      this.loading = true;
      this.filtro = {
        full_name: this.buscarNombre || undefined,
        role_id: this.filtrarRol || undefined,
        ponencia_id: this.filtrarPonencia || undefined
      }
      this.$store.dispatch("GET_USERS", { url: "/users", params:this.filtro }).then((response) => {
        this.loading = false;
      }).catch(err => {
        console.log(err);
      });
    },
    getRoles() {
      this.$store.dispatch("GET_ROLES",  { url: "/roles" });
    },
    getPonencias() {
      this.$store.dispatch("GET_PONENCIAS",  { url: "/ponencias" });
    },
    editItem (item) {
      this.editedIndex = this.listUsers.indexOf(item)
      this.editedItem.id = item.id
      this.editedItem.role = item.roles[0].id
      if (item.sala_id) {
        this.editedItem.sala_id = item.sala_id
      }
      if (item.ponencia != null) {
        this.editedItem.ponencia_id = item.ponencia.id
        this.editedItem.ponencia = item.ponencia
        this.editedItem.sala_id = item.ponencia.sala_id
      }
      this.editedItem.nombre = item.nombre
      this.editedItem.primer_apellido = item.primer_apellido
      this.editedItem.segundo_apellido = item.segundo_apellido
      this.editedItem.email = item.email
      this.editedItem.password = item.password
      this.editedItem.password_confirmation = item.password_confirmation
      this.editedItem.deleted_at = item.deleted_at
      if (this.editedItem.deleted_at) this.activo = false
      else this.activo = true
      this.dialog = true
    },
    addUser(item){
      if (item.sala_id) {
        this.editedItem.sala_id = item.sala_id
      } else{ item.sala_id = item.ponencia.sala_id}
      if (item.ponencia != null) {
        this.editedItem.ponencia_id = item.ponencia.id
        this.editedItem.ponencia = item.ponencia
      }
      if (this.editedItem.password != this.editedItem.password_confirmation) {
        this.$swal({
          icon: 'error',
          title: 'Error!!!',
          text: 'Las contraseñas no coinciden, favor de verificarlas.',
          confirmButtonText: "Aceptar"
        })
        return false;
      }
      if (this.$refs.form.validate()) {
        this.$store.dispatch("SAVE_USERS",  { url: "/user", data: item } ).then(response => {
          this.close ();
          this.$swal({
            icon: 'success',
            title: 'Usuario guardado correctamente',
            confirmButtonText: "Aceptar"
          })
          this.getUsers();
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            icon: 'error',
            title: error.response.data.errors.email,
            confirmButtonText: "Aceptar"
          })
        });
      }
    },
    editUser(item){
      if (item.sala_id) {
        this.editedItem.sala_id = item.sala_id
      }
      if (item.ponencia != null) {
        this.editedItem.ponencia_id = item.ponencia.id
      }
      if (this.editedItem.password != this.editedItem.password_confirmation) {
        this.$swal({
          icon: 'error',
          title: 'Error!!!',
          text: 'Las contraseñas no coinciden, favor de verificarlas.',
          confirmButtonText: "Aceptar"
        })
        return false;
      }
      if (this.$refs.form.validate()) {
        item.activo = this.activo
        this.$store.dispatch("EDIT_USER",  { url: "/user/" + item.id, data: item } ).then(response => {
          this.$swal({
            icon: 'success',
            title: 'Usuario actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.close();
          this.getUsers();
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            icon: 'error',
            title: error.response.data.errors.email,
            confirmButtonText: "Aceptar"
          })
        });
      }
    },
    deleteUser(item){
      this.$swal({
        title: '¿Desea eliminar al usuario "' + item.nombre + '"?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DELETE_USER",  { url: "/user/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Usuario eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getUsers();
          })
          .catch(err => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: err.response.data.msg,
              confirmButtonText: "Aceptar"
            })
          });
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
    startImpersonated(item){
      this.$store.dispatch("IMPERSONATE_START",
        { url: "/impersonate/" + item.id + '/start' } )
      .then(response => {
        response.data.data.user.impersonated = true;
        localStorage.setItem("token", response.data.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
        window.location = "/"
        this.$swal({
          icon: 'success',
          title: 'Impersonated successfuly!!!',
          confirmButtonText: "Aceptar"
        })
      }).catch(error => {
        console.log(error);
      });
    }
  }
}
</script>
